module.exports = __webpack_public_path__ + "img/FR16488.c12dd4ac.svg";